import React from 'react'
import * as reviewerCommentType from './reviewerCommentType'

import arrayMutators from 'final-form-arrays'
import MyAccordion from '../../../../../control/accordion/accordion'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../i18n/useTranslate'
import ResultConsideration from '../../../shareUI/resultConsideration/resultConsideration'
import CommentDirector from '../../../shareUI/commentDirector/commentDirector'
import Autocomplete from '../../../../../control/autocomplete/autocomplete'
import UploadDoc from '../../../shareUI/uploadDoc/uploadDoc'
import useReviewerComment from './useReviewerComment'
import Dialog from '../../../../../control/dialog/dialog'
import PageAction from '../pageAction'
import Button from '../../../../../control/button/button'

import { Form, FormSpy } from 'react-final-form'
import { Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import CopyToclipboard from '../../../../../control/copyToClipboard/copyToclipboard'
import ExportToMSWord from '../../../../../control/exportToMSWord/exportToMSWord'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../../utilities/date'
import useCommentaryStore from '../../../../../stores/commentary/useCommentaryStore'

const ReviewerCommentREC1View: React.FC<reviewerCommentType.ReviewerCommentViewType> = (props) => {
    const {
        role,
        formRef,
        director,
        isViewMode,
        isCommittee,
        isUserChairman,
        configDialog,
        initialValues,
        documentTopic,
        initialComment,
        commentTitleList,
        initialUploadFile,
        isDisplayCopyToClipboard,
        dataSourceForCopyToClipboard,
        projectData,
        showSaveDraft,
        dataSourceForExport,
        dataForShowUpdateDate,
        onSubmitForm,
        onClickCancel,
        onDirtyChange,
        onChangStatus,
        onRefDialogTwo,
        onChangeDirector,
        onClickBackToSearch,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()
    const classes = useStyles()
    const isDisable = initialValues?.isDisableFrm || isViewMode
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const irb = projectData?.irb
    const { selectedCommitteeID } = useCommentaryStore()

    const renderMainReviewer = (change: <F extends string | number | symbol>(name: F, value?: any) => void) => {
        return (
            <React.Fragment>
                <Grid item xs={12} md={6} lg={6} className={classes.grid}>
                    <Autocomplete
                        name="director"
                        materialInputProps={{
                            label: translate.get('LABEL.COMMITTEE_NAME'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                        }}
                        options={director}
                        onChangeValue={(val) => {
                            onChangeDirector(val, change)
                        }}
                        required
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} className={classes.grid}>
                    <Autocomplete
                        name="role"
                        materialInputProps={{
                            label: translate.get('LABEL.ROLE'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                            disabled: true,
                        }}
                        options={role}
                        required
                    />
                </Grid>
            </React.Fragment>
        )
    }

    return (
        <>
            {isDisplayCopyToClipboard && (
                <Grid container spacing={2} xs={12} justify={'flex-end'} className={classes.btnGroup}>
                    <ExportToMSWord dataSource={dataSourceForExport} irb={Number(irb)} />
                    <CopyToclipboard dataSource={dataSourceForCopyToClipboard} pageType={'1'} />
                </Grid>
            )}
            <Form
                onSubmit={onSubmitForm}
                initialValues={{ ...initialValues, commentDirector: initialComment, uploadFile: initialUploadFile }}
                mutators={{
                    ...arrayMutators,
                }}
                keepDirtyOnReinitialize={true}
            >
                {(props) => {
                    const { form, handleSubmit, dirty, invalid, errors } = props
                    formRef.current = form
                    return (
                        <React.Fragment>
                            <Grid container spacing={2} justify="flex-end">
                                {(!isCommittee || isUserChairman) && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <MyAccordion title={translate.get('LABEL.REVIEWER_COMMENT')}>
                                            <Grid container spacing={2}>
                                                {renderMainReviewer(form.change)}
                                            </Grid>
                                        </MyAccordion>
                                    </Grid>
                                )}

                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <CommentDirector
                                        commentTitleList={commentTitleList}
                                        committeeID={selectedCommitteeID?.toString()}
                                        disabled={isDisable}
                                        initialcomment={initialComment}
                                        isViewMode={isViewMode}
                                    />
                                </Grid>

                                <Grid item xs={12} md={12} lg={12} xl={12}>
                                    <UploadDoc
                                        documentTitleList={documentTopic}
                                        initialData={initialUploadFile}
                                        isViewMode={isDisable}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <ResultConsideration
                                        irb={irb}
                                        disabled={isDisable}
                                        onChangStatus={onChangStatus}
                                        isCommitee={1}
                                    />
                                </Grid>

                                {initialValues.isShowUpdateDate && (
                                    <Grid container item xs={12} justify="flex-end">
                                        {translate.get('LABEL.UPDATER')} :
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? dataForShowUpdateDate?.nameTH
                                            : dataForShowUpdateDate?.nameEN}
                                        &nbsp;&nbsp;
                                        {translate.get('LABEL.UPDATE_DATE')} :
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? convertDateToFormatTH(dataForShowUpdateDate?.date ?? '')
                                            : convertDateToFormatEN(dataForShowUpdateDate?.date ?? '')}
                                    </Grid>
                                )}

                                {!isDisable && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <PageAction
                                            onClickClose={() => {
                                                onClickCancel(dirty)
                                            }}
                                            onClickSave={() => {
                                                form.change('submitType', 'save')
                                                handleSubmit()
                                                invalid &&
                                                    errors &&
                                                    snackbarAction.openSnackbar({
                                                        message: translate.get('MESSAGE.M012'),
                                                        type: 'error',
                                                    })
                                            }}
                                            onClickSaveDraft={
                                                showSaveDraft
                                                    ? () => {
                                                          form.change('submitType', 'draft')
                                                          handleSubmit()
                                                      }
                                                    : undefined
                                            }
                                        />
                                    </Grid>
                                )}

                                {isDisable && !isViewMode && (
                                    <Grid container item xs={12} sm={6} md={6} lg={6} xl={6} justify="flex-end">
                                        <Button
                                            color="primary"
                                            onClick={onClickBackToSearch}
                                            fullWidth={isMobileView ? true : false}
                                        >
                                            {translate.get('BUTTON.CLOSE')}
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                            <Dialog onRef={onRefDialogTwo} {...configDialog} />
                            <FormSpy subscription={{ values: true }} onChange={onDirtyChange} />
                        </React.Fragment>
                    )
                }}
            </Form>
        </>
    )
}

const ReviewerCommentREC1: React.FC<reviewerCommentType.ReviewerCommentType> = (props) => {
    const useReviewerCommentModel = useReviewerComment(props)
    return <ReviewerCommentREC1View {...useReviewerCommentModel} {...props} />
}

const useStyles = makeStyles(() => ({
    grid: {
        marginBottom: '0px',
    },
    btnGroup: {
        padding: '18px',
    },
}))

export default ReviewerCommentREC1
